import { Skeleton } from '@nexelem/components';

type TreeViewSkeletonProps = {
  rowsCount: number;
};

export const TreeViewSkeleton = ({ rowsCount }: TreeViewSkeletonProps) => (
  <div>
    {[...Array(rowsCount)].map((_, index) => (
      <div className="flex items-center gap-4 border-b border-border-secondary py-2 pr-3 pl-5" key={index}>
        <Skeleton className="size-4.5" />
        <Skeleton className="size-7 rounded-full" />
        <div className="flex grow flex-col gap-1">
          <Skeleton className="h-4.5" />
          <Skeleton className="h-3.5 w-7/10" />
        </div>
        <Skeleton className="size-7" />
      </div>
    ))}
  </div>
);
